import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import NeedAttentionHeader from "./NeedAttentionHeader";
import NeedAttentionHeaderSkeleton from "./NeedAttentionHeaderSkeleton";
import NeedAttentionTabs from "./NeedAttentionTabs/NeedAttentionTabs";
import NeedAttentionTabsSkeleton from "./NeedAttentionTabs/NeedAttentionTabsSkeleton";
import { selectUserToken } from "../../../../features/userSlice";
import { familiesEndPointLogic } from "../../../../logic/DataCollection/Families/FamiliesEndPointLogic";
import { useWebsiteSharedUid } from "../../../../customHooks/useWebsiteSharedUid";

const NeedAttention = () => {
  const dispatch = useDispatch();
  const oauthTokenHeader = useSelector(selectUserToken) as any;
  const { needsAttentionRows, isNeedsAttentionLoading } = useSelector(
    (state: any) => state.families,
  );

  // Families data spans all interfaces/brands, not scoped to one website —
  // the EP treats website_shared_uid as a required dummy input here, so we
  // pass the first website_shared_uid the user can access from /me.
  const website_shared_uid = useWebsiteSharedUid();

  useEffect(() => {
    familiesEndPointLogic.getNeedsAttentionSummary(
      oauthTokenHeader,
      website_shared_uid,
      dispatch,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const totals = useMemo(
    () =>
      needsAttentionRows.find((row: any) => row.row_type === "total") ?? {
        empty_families: 0,
        missing_things: 0,
      },
    [needsAttentionRows],
  );

  const stepSummary = useMemo(
    () => needsAttentionRows.filter((row: any) => row.row_type === "step_summary"),
    [needsAttentionRows],
  );

  const familyRows = useMemo(
    () => needsAttentionRows.filter((row: any) => row.row_type === "family"),
    [needsAttentionRows],
  );

  return (
    <>
      {isNeedsAttentionLoading ? (
        <>
          <NeedAttentionHeaderSkeleton />
          <NeedAttentionTabsSkeleton />
        </>
      ) : (
        <>
          <NeedAttentionHeader totals={totals} stepSummary={stepSummary} />
          <NeedAttentionTabs familyRows={familyRows} />
        </>
      )}
    </>
  );
};

export default NeedAttention;
